import { GlobalOutlined, LockOutlined, CheckOutlined } from "@ant-design/icons";
import { ACCESS_ANYONE, ACCESS_RESTRICTED } from "../shareConstants";
import "./AccessSelector.css";

const OPTIONS = [
  {
    key: ACCESS_RESTRICTED,
    title: "Restricted",
    description: "Only people you add can open this link",
    Icon: LockOutlined,
  },
  {
    key: ACCESS_ANYONE,
    title: "Anyone with the link",
    description: "No sign-in needed — anyone can view",
    Icon: GlobalOutlined,
  },
];

/**
 * Access level as two selectable cards rather than a dropdown: it is the most
 * consequential choice in the dialog, so both outcomes stay on screen with
 * their consequence spelled out.
 */
export const AccessSelector = ({ type, setType }) => (
  <div className="access-selector" role="radiogroup" aria-label="General access">
    {OPTIONS.map(({ key, title, description, Icon }) => {
      const isSelected = key === type;
      return (
        <button
          type="button"
          key={key}
          role="radio"
          aria-checked={isSelected}
          className={`access-card ${isSelected ? 'access-card--selected' : ''}`.trim()}
          onClick={() => setType(key)}
        >
          <span className="access-card__icon">
            <Icon />
          </span>
          <span className="access-card__body">
            <span className="access-card__title">{title}</span>
            <span className="access-card__desc">{description}</span>
          </span>
          <span className="access-card__check">
            <CheckOutlined />
          </span>
        </button>
      );
    })}
  </div>
);
